module.exports = __webpack_public_path__ + "static/hero-5-c7ccbb97958ee216e919f4aef376d124.png";